// @Version: 1.0.0
import { Injectable } from "@angular/core";

export type TRecord = Record<string, Object> | Object[]
@Injectable({
   providedIn: 'root'
})
export class JsonHelpersService {


   constructor() { }

   private isEmptyArray(obj: Object): boolean {
      const property = Object.getOwnPropertyNames(obj)
      return property.length == 1 && property[0] == 'length' ? true : false
   }

   public flatten(obj: Object, isField: boolean = false) {
      const keySeparator = '.'
      const flattenRecursive = (obj: object, parentProperty?: string, propertyMap: Record<string, unknown> = {}) => {
         for (const [key, value] of Object.entries(obj)) {
            const property = parentProperty ? `${parentProperty}${keySeparator}${key}` : key;
            if ((!isField && value && !this.isPrimitive(value)) || (isField && value && !this.isPrimitive(value) && !('type' in value))) {
               if (Object.getOwnPropertyNames(value).length == 0) propertyMap[property] = {}
               else if (this.isEmptyArray(value)) propertyMap[property] = []
               else flattenRecursive(value, property, propertyMap);
            } else {
               propertyMap[property] = value;
            }
         }
         return propertyMap;
      };
      return flattenRecursive(obj);
   }

   public flattenByKey(obj: Object, key: string) {
      const keySeparator = '.'

      const flattenRecursive = (obj: object, parentProperty?: string, propertyMap: Record<string, unknown> = {}) => {
         for (const [key, value] of Object.entries(obj)) {
            const property = parentProperty ? `${parentProperty}${keySeparator}${key}` : key;
            if (value && !this.isPrimitive(value)) {
               if (Object.getOwnPropertyNames(value).length == 0) propertyMap[property] = {}
               else if (this.isEmptyArray(value)) propertyMap[property] = []
               else flattenRecursive(value, property, propertyMap);
            } else {
               propertyMap[property] = value;
            }
         }
         return propertyMap;
      };
      return flattenRecursive(obj);
   }

   /**
    * Bonus function to unflatten an object
    *
    * @param ob Object     The object to unflatten
    */
   public unflatten(ob: Object, refactor: boolean = true) {
      const result = this.startsWithArray(Object.keys(ob)[0]) ? [] : {}
      for (const i in ob) {
         if (Object.prototype.hasOwnProperty.call(ob, i)) {
            const keys = i.match(/^\.+[^.]*|[^.]*\.+$|(?:\.{2,}|[^.])+(?:\.+$)?/g); // Just a complicated regex to only match a single dot in the middle of the string
            keys?.reduce((r: { [key: string]: any }, e, j) => {
               return r[e as keyof typeof r] || (r[e as keyof typeof r] = isNaN(Number(keys[j + 1])) ? (keys.length - 1 === j ? ob[i as keyof typeof ob] : {}) : []);
            }, result);
         }
      }
      return refactor ? this.refactorObject(result) : result;
   }

   private startsWithArray(key: string): boolean {
      if (!key || key == '') return false
      const keys = key.match(/^\.+[^.]*|[^.]*\.+$|(?:\.{2,}|[^.])+(?:\.+$)?/g);
      return keys && keys.length > 0 && !isNaN(Number(keys[0])) ? true : false
   }

   private refactorObject(obj: Object): Object {
      if (obj == null) return obj
      return Object.keys(obj).reduce(
         (acc, key, index) => {
            return Object.assign(acc, {
               [!isNaN(Number(key)) ? index : key]: !this.isPrimitive(obj[key as keyof typeof obj]) ? this.refactorObject(obj[key as keyof typeof obj]) : obj[key as keyof typeof obj]
            })
         },
         Array.isArray(obj) ? [] : {}
      );
   }


   /**
    * **************************************
    * Rename
    * **************************************
    */

   /**
    * Mit (*) umfasst, beliebig in der MItt
    * Ohne (*) am Anfang: Muss beginnen mit diesem Teil
    * Ohne (*) am Ende: Muss enden mit diesem Teil
    * 
    * @param item Original key
    * @param rename der zu ersetzende Teil
    * @param replaceValue: neuer Textausschnitt
    * @returns string transformierter Key
    */

   private renameItem = (item: string, rename: string, replaceValue: string,): string => {
      const reg = new RegExp(`${(/^\*/g.exec(rename) ? '' : '^')}${rename.replace(/\./g, '\.').replace(/\*/g, '')}${/\*$/g.exec(rename) ? '' : '$'}`, 'g')
      return item.replace(reg, replaceValue)
   }


   /**
    * 
    * @param key Einzelne key zur Umbenennung
    * @param keysMap Anreihung von Umbennenungen
    */
   private renameWithAllKeyMaps(key: string, keysMap: {}): string {
      let newKey = key
      Object.keys(keysMap).forEach(key => newKey = this.renameItem(newKey, key, keysMap[key as keyof typeof keysMap]))
      return newKey
   }



   /***
      * Rename
      * @param keysMap rename
      * @param obj Object
      */
   private renameKeys_ = (keysMap: Object, obj: Object): Object =>
      Object.keys(obj).reduce(
         (acc, key) => ({
            ...acc,
            ...{ [this.renameWithAllKeyMaps(key, keysMap)]: obj[key as keyof typeof obj] }
         }),
         Array.isArray(obj) ? [] : {}
      );

   public arrayToObject = (obj: Object): Object =>
      Object.keys(obj).reduce(
         (acc, key) => ({
            ...acc,
            ...{ [key.substring(key.indexOf('.') + 1)]: obj[key as keyof typeof obj] }
         }),
         Array.isArray(obj) ? [] : {}
      );


   public cutLastElement(value: string, searchKey: string[]): string {
      const meta = searchKey.filter(item => value.indexOf(item) > -1).map(item => {
         return {
            pos: value.indexOf(item),
            length: item.length
         }
      })[0] || -1
      return typeof meta == 'object' ? value.substring(meta.pos + meta.length, value.length) : ''
   }

   /**
    * 
    * @param keysMap Anreihung von Umbennenungen 
    * @param obj Object das transformiert werden soll
    * @returns transformierte Object
    */
   public rename = (keysMap: Object, obj: Object): Object =>
      this.unflatten(this.renameKeys_(this.flatten(keysMap), this.flatten(obj)))

   /**
    * *****************************
    * Search
    * *******************************
    */

   /**
    * ** Beliebig viele Ebenen
    * * nicht am anfang oder Ende
    * 
    * @param searchItem 
    * @param original 
    * @returns 
    */

   private searchItem_ = (searchItem: string, original: string) => {
      const reg = (searchItem.substring(0, 1) != '*' || searchItem.substring(0, 2) == '*.' ? '^' : '') + searchItem
         .replace(/\./, '\.') //. Maskieren
         .replace(/\*\*\.?/g, '##') // ** in .* ersetzen
         .replace(/\*\.\?/g, '((\.[0-9]{1,5}\.)?[a-zA-Z0-9_]{1,}\.)\?') //*. in eine Optionale Ebene ersetzen und Array mit berücksichtigen .0.  wird nicht als ebene angesehen
         .replace(/\*\./g, '(\.[0-9]{1,5}\.)?[a-zA-Z0-9_]{1,}\.') //*. in eine Ebene ersetzen und Array mit berücksichtigen .0. wird nicht als ebene angesehen
         .replace(/^\*/g, '.*') // Erste Sternchen entfernen und mit beliebig nach vorne ersetzen...
         .replace(/\.\*$/g, '\.') // letzte Sternchen entfernen
         .replace(/\*$/g, '([0-9]{1,5}\.)?[a-zA-Z0-9_]{1,}\.') // letzte Sternchen entfernen ohne punkt
         .replace(/##/g, '.*')
         .trim()
         + (searchItem.substring(searchItem.length - 1, searchItem.length) != '*' ? '$' : '')
      let regExp: RegExp = new RegExp(reg.trim(), 'g')
      const res = regExp.exec(original)
      return res && res[0] != '' ? res[0].replace(/\.$/g, '') : '-1'
   }

   private searchItem = (searchValue: string, obj: Object): Object =>

      Object.keys(obj).filter(key => this.searchItem_(searchValue, key) != '-1').reduce(
         (acc, key) => ({
            ...acc,
            ...{ [key]: obj[key as keyof typeof obj] }
         }),
         Array.isArray(obj) ? [] : {}
      );

   public search = (search: string, obj: Object): Object => {
      return this.unflatten(this.searchItem(search, this.flatten(obj)))
   }

   /**
    * 
    * @param searchKey Der zu suchende Key
    * @param searchValue Der Inhalt der es sein muss
    * @param obj Das zu durchsuchende Objekt
    * @param returnValue Objektanteil der zurückgegeben werden soll
    * @returns 
    */
   public searchByKeyValue = (searchKey: string, searchValue: string | number | boolean | BigInt, obj: Object, returnValue: string, lastElement: boolean = false, refactor: boolean = true): Object => {
      const flatten = this.flatten(obj)
      const filterResult = this.transformReturnArray(searchKey, searchValue, flatten, returnValue)
      let result = Object.fromEntries(Object.entries(flatten).filter(([key, value]) => {
         return this.checkInReturnArray(key, filterResult)
      }))
      if (Object.keys(result).length == 0 && Array.isArray(obj)) return []

      return this.unflatten(lastElement
         ? Object.keys(result)
            .reduce(
               (acc, key) => ({
                  ...acc,
                  ...{ [this.cutLastElement(key, filterResult)]: result[key] }
               }),
               Array.isArray(result) ? [] : {}
            )
         : result, refactor
      )
   }

   private checkInReturnArray(current: string, returnArray: string[]): boolean {
      return returnArray.filter(item => current.indexOf(item) == 0).length > 0
   }

   private transformReturnArray(searchKey: string, searchValue: string | number | boolean | BigInt, flatten: Object, returnValue: string): string[] {

      return Object.entries(this.searchItem(searchKey, flatten))
         .filter(([key, value]) => value == searchValue)
         .map(([key, value]) => {
            const reg = returnValue
               .replace(/\.\.\//g, '[a-zA-Z0-9_]{1,}\.([0-9]{1,5}\.)?\.')
               .replace(/\.\//g, '[a-zA-Z0-9_]{1,}$')
            const regExp = new RegExp(reg.trim(), 'g')
            const res = regExp.exec(key)
            return res ? key.substring(0, key.length - res![0].length) : ''
         })
   }

   private sortByKey_ = (sortKey: string, obj: Object, type: string = 'number', asc: boolean = true): Object | Object[] =>
      Array.isArray(obj) ?
         <Object[]>obj.sort((a, b) => { return this.sorObject(a, b, sortKey, type, asc) }) :
         Object.fromEntries(Object.entries(obj).sort(([, a], [, b]) => this.sorObject(a, b, sortKey, type, asc)))

   public sortByKey = (sortKey: string, obj: Object, type: string = 'number', asc: boolean = true): Object | Object[] =>
      Array.isArray(obj)
         ? (this.sortByKey_(sortKey, obj, type, asc) as Object[]).map(item => (!this.isPrimitive(item) ? this.sortByKey_(sortKey, item, type, asc) : item))
         : Object.keys(obj).reduce(
            (acc, key) => ({
               ...acc,
               ...{ [key]: (!this.isPrimitive(obj[key as keyof typeof obj]) ? this.sortByKey_(sortKey, obj[key as keyof typeof obj], type, asc) : obj[key as keyof typeof obj]) }
            }),
            Array.isArray(obj) ? [] : {}
         )


   private sorObject(current: {}, next: {}, sortKey: string, type: string = 'number', asc: boolean = true): number {
      if (current == undefined || Object.keys(current).length == 0 || Object.keys(current).filter(keys => keys == sortKey).length == 0) return 0
      if (next == undefined || Object.keys(next).length == 0 || Object.keys(next).filter(keys => keys == sortKey).length == 0) return 0

      switch (type) {
         case 'date':
            return asc ? new Date(current[sortKey as keyof typeof current]) > new Date(next[sortKey as keyof typeof current]) ? 1 : -1
               : new Date(current[sortKey as keyof typeof current]) > new Date(next[sortKey as keyof typeof current]) ? -1 : -1
         default:
            return asc ? current[sortKey as keyof typeof current] - next[sortKey as keyof typeof next] : next[sortKey as keyof typeof next] - current[sortKey as keyof typeof current]
      }
   }


   public getValueBySearch(searchValue: string, obj: Object): string | boolean | number | BigInt | undefined | Object {
      const search = this.searchItem(searchValue, this.flatten(obj))
      return search[(Object.keys(search)[0]) as keyof typeof search]

   }

   public setValueBySearchKeyValue = (original: Object, newKey: string, newValue: Object | boolean | number | BigInt | undefined | string, searchKey: string, searchValue: boolean | number | BigInt | string, refactor: boolean = false, returnValue: string = './'): Object => {
      const flatten = this.flatten(original)
      const searchKeyResult = Object.keys(this.flatten(this.searchByKeyValue(searchKey, searchValue, original, returnValue, false, refactor)))
         .filter(key => this.searchItem_('**' + newKey, key) != '-1')
         .map(key => this.searchItem_('**' + newKey, key))[0] || ''


      const mergingItem = Object.keys(flatten)
         .filter(key => key.indexOf(searchKeyResult) > -1)
      const flattenNewValue = newValue && !this.isPrimitive(newValue) && mergingItem.length > 1 ? this.flatten(newValue) : newValue

      mergingItem
         .forEach(key => {
            flatten[key] = flattenNewValue && !this.isPrimitive(flattenNewValue) && mergingItem.length > 1
               ? flattenNewValue[Object.keys(flattenNewValue).filter(keyNewValue => key.indexOf(keyNewValue) > -1)[0] as keyof typeof flattenNewValue] : flattenNewValue
         })
      return this.unflatten(flatten)
   }

   private castObject_ = (original: {}): Object =>
      Object.keys(original).reduce(
         (acc, key) => ({
            ...acc,
            ...{ [key]: (original[key as keyof typeof original] && !this.isPrimitive(original[key as keyof typeof original]) ? this.castObject_(original[key as keyof typeof original]) : this.castPrimitive(original[key as keyof typeof original])) }
         }),
         Array.isArray(original) ? [] : {}
      )

   private castPrimitive(value: string): boolean | string | number | Date | BigInt {
      if (value == 'false') return false
      else if (value == 'true') return true
      else if (value == "") return value
      else if (!isNaN(Number(value))) return Number(value)
      else if (/^[0-9]{4}-[0-9]{2}-[0-9]{2}( [0-9]{2}:[0-9]{2})?$/.exec(value) !== null && !isNaN(Date.parse(value.toString()))) return new Date(value)

      return value
   }

   public isPrimitive(value: boolean | string | number | Date | BigInt | Object): boolean {
      if (!value) return true
      if (typeof value == 'boolean' || typeof value == 'string' || typeof value == 'number') return true
      else if (!isNaN(Date.parse(value.toString()))) return true
      return false
   }

   public castObject = (original: Object): Object => this.unflatten(this.castObject_(this.flatten(original)))


   public objCompareSimple(obj1: Object, obj2: Object) {
      const Obj1_keys = Object.keys(obj1);
      const Obj2_keys = Object.keys(obj2);
      if (Obj1_keys.length !== Obj2_keys.length) {
         return false;
      }
      for (let k of Obj1_keys) {
         if (obj1[k as keyof typeof obj1] !== obj2[k as keyof typeof obj2]) {
            return false;
         }
      }
      return true;
   }
}




